import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { GetInvoicesDue } from '../../features/data/data.actions';
import { selectInvoices } from '../../features/data/data.selectors';

@Component({
  selector: 'app-signup06',
  templateUrl: './signup06.component.html',
  styleUrls: ['./signup06.component.scss']
})
export class Signup06Component implements OnInit {

  public invoices$ = this.store.pipe(
    select(selectInvoices)
  );

  constructor(
    private store: Store
  ) { }

  ngOnInit(): void {
    this.store.dispatch({
      type: GetInvoicesDue.type
    });
  }

  goToDashboard(): void {
    window.location.href = '/org.html';
  }
}
